import * as m from './mutations'
import * as a from './actions'

const initialState = () => ({
  product: null,
  allSubjectCategories: [],
  assignedSubjectCategories: [],
  fetchingSubjectCategories: false,
  editingData: null,
  titleLists: null,
  subscriptions: null
})

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    setProduct: m.setProduct,
    updateUncompletedTodos: m.updateUncompletedTodos,
    setAllSubjectCategories: m.setAllSubjectCategories,
    addSubjectCategory: m.addSubjectCategory,
    setAssignedSubjectCategories: m.setAssignedSubjectCategories,
    assignSubjectCategory: m.assignSubjectCategory,
    removeActiveMainCategory: m.removeActiveMainCategory,
    setActiveMainCategory: m.setActiveMainCategory,
    removeSubjectCategory: m.removeSubjectCategory,
    toggleFetchingSubjectCategories: m.toggleFetchingSubjectCategories,
    setEditingData: m.setEditingData,
    setTitleLists: m.setTitleLists,
    setSubscriptions: m.setSubscriptions,

    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetData: a.getAndSetData,
    fetchAssignedSubjectCategories: a.fetchAssignedSubjectCategories,
    updateProduct: a.updateProduct,
    createSubjectCategory: a.createSubjectCategory,
    assignSubjectCategory: a.assignSubjectCategory,
    changeMainCategory: a.changeMainCategory,
    removeFromProduct: a.removeFromProduct,
    getAndSetTitleLists: a.getAndSetTitleLists,
    getAndSetSubscriptions: a.getAndSetSubscriptions,
    updateField: a.updateField
  }
}
